const actions = {
  FETCH_INCOMPLETE_JOB_START: 'FETCH_INCOMPLETE_JOB_START',
  FETCH_INCOMPLETE_JOB_DONE: 'FETCH_INCOMPLETE_JOB_DONE',
  FETCH_INCOMPLETE_JOB_ERROR: 'FETCH_INCOMPLETE_JOB_ERROR',
  REMOVE_JOB_FROM_STATE: 'REMOVE_JOB_FROM_STATE',
  HIDE_JOB: 'HIDE_JOB',


  fetchIncompleteJobs: () => ({
    type: actions.FETCH_INCOMPLETE_JOB_START,
  }),

  removeJobFromState: (uid: string) => ({
    type: actions.REMOVE_JOB_FROM_STATE,
    payload: uid,
  }),

  hideJob: (uid: string) => ({
    type: actions.HIDE_JOB,
    payload: uid,
  }),
}


export default actions;